import { DeepPartial, TrackAddToCartConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_TRACK_ADD_TO_CART: DeepPartial<TrackAddToCartConfig> = { buttonsSelector: '.action-product .buttonCompra .btn' };
